import { IFormField, IFormFieldRenderer, getFractionDigits } from '@migrate/utils/form/form'
import renderNumeric from '@migrate/utils/renderer/Numeric'

export interface INumberFormatOptions {
  minimumFractionDigits?: number
  maximumFractionDigits?: number
}

export class NumericRenderer implements IFormFieldRenderer {
  render(field: IFormField) {
    const fractionDigits = getFractionDigits(field)
    const unit = field.meta.unit
    return renderNumeric(field.value, fractionDigits, fractionDigits, unit)
  }
}
